import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAttachTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 15" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#007AFF">
      <path d="m16 5-2.454-2L11 5" />
      <path d="M20.867 1C21.493 1 22 1.474 22 2.06v9.98c0 .774-.672 1.403-1.501 1.403-.33 0-.65-.102-.912-.289l-1.69-1.209a1.195 1.195 0 0 0-1.42.032L14.23 13.75a1.194 1.194 0 0 1-1.46.002l-2.262-1.777a1.195 1.195 0 0 0-1.419-.029l-1.683 1.208c-.655.47-1.593.355-2.096-.258a1.34 1.34 0 0 1-.309-.85V10" />
      <path d="M5 6V2.06C5 1.474 5.507 1 6.133 1H21" />
      <path d="M.5 8h11a2 2 0 0 0 2-2V3" />
    </g>
  </svg>
);
const Memo = memo(SvgAttachTicket);
export default Memo;
